import { useTexts } from './useTexts';
import { CellFormatOptions } from '@octano/global-ui';
import { Badge } from 'reactstrap';
import { getLessonStatus } from '../utils';
import { useGetJustificationStatusOptions } from './useGetJustificationStatusOptions';

export function useColumns() {
  const texts = useTexts();
  const JustificationStatusOptions = useGetJustificationStatusOptions();
  return [
    {
      columnName: 'responsible',
      headerText: texts.table.responsible,
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'faculty',
      headerText: texts.table.faculty,
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'course',
      headerText: texts.table.course,
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'section',
      headerText: texts.table.section,
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'date',
      headerText: texts.table.date,
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'moduleStart',
      headerText: texts.table.initialModule,
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'moduleEnd',
      headerText: texts.table.endModule,
      tdClassName: 'text-center',
      thClassName: 'text-center',
    },
    {
      columnName: 'status',
      headerText: texts.table.classState,
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: (data: CellFormatOptions<any>) => {
        return (
          <div className="d-flex justify-content-start" style={{ gap: 10 }}>
            <div
              style={{
                borderRadius: 4,
                width: 24,
                height: 20,
                backgroundColor:
                  data.row.status !== 'no-ejecutada' ? '#FFE6A1' : '#F2C0BD',
              }}
            />
            <span>{getLessonStatus(data.row.status)?.label}</span>
          </div>
        );
      },
    },
    {
      columnName: 'justification',
      headerText: texts.table.justification,
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: (data: CellFormatOptions<any>) => {
        return (
          <div
            style={{
              padding: '5px',
              borderRadius: 5,
              border: '1px solid var(--primary)',
              color: 'var(--primary)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: data.row.justification && '#FFE6A1',
            }}
            className="text-capitalize"
          >
            JUSTIFICADO
          </div>
        );
      },
    },
    {
      columnName: 'justificationState',
      headerText: texts.table.justificationStatus,
      tdClassName: 'text-center',
      thClassName: 'text-center',
      cellFormat: (data: CellFormatOptions<any>) => {
        const justificationStatus = data.row.justificationStatus;
        const backgroundColor =
          (justificationStatus === 'approved' && '#CEF0DA') ||
          (justificationStatus === 'rejected' && '#F2C0BD') ||
          '#FFE6A1'; //esta pendiente o no se le ha asignado estado aun
        return (
          <Badge
            className="fs-14 fw-400 py-2 px-3 text-dark"
            style={{
              backgroundColor,
            }}
            pill
          >
            {
              JustificationStatusOptions.find(
                (item) => item.value === justificationStatus,
              )?.label
            }
          </Badge>
        );
      },
    },
  ];
}
